import { render, staticRenderFns } from "./LockingRoadWay.vue?vue&type=template&id=574c36fb"
import script from "./LockingRoadWay.vue?vue&type=script&lang=js"
export * from "./LockingRoadWay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports